var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',_vm._b({},'el-col',_vm.$attrs,false),[_c('div',{staticClass:"detail-item",style:(_vm.itemStyle)},[_c('div',{style:(_vm.labelStyle)},[_vm._v(" "+_vm._s(_vm.labelStr)+" ")]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }